/**
 * PublicStorageModel — mirrors ConneXt v2 CommonStorageModel.
 * Exposes window.Connext.Storage / window.CnnXt.Storage methods.
 */
import { View } from '@Engage.Data/modules/view/View';
import { UserStore } from '../../plugins/auth/model/UserStore';
import { AppOptions } from '../../application/options/AppOptions';
import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
import { StorageKeys } from '@Engage.Data/constants/Constants';
/** Cached paywall response data */
let cachedConversationName = '';
let cachedConversationId = -1;
let cachedConversationCode = '';
let cachedActions = [];
let cachedCampaignId = 0;
let cachedCampaignName = '';
let cachedConversationType = '';
export function updateCachedConversationData(data) {
    if (data.conversationName !== undefined)
        cachedConversationName = data.conversationName;
    if (data.conversationId !== undefined)
        cachedConversationId = data.conversationId;
    if (data.conversationCode !== undefined)
        cachedConversationCode = data.conversationCode;
    if (data.conversationType !== undefined)
        cachedConversationType = data.conversationType;
    if (data.campaignId !== undefined)
        cachedCampaignId = data.campaignId;
    if (data.campaignName !== undefined)
        cachedCampaignName = data.campaignName;
    if (data.actions !== undefined)
        cachedActions = data.actions;
}
export class PublicStorageModel {
    GetCurrentConversation() {
        var _a;
        const viewCount = View.getCurrentConversationViewCount() || 0;
        return {
            Id: cachedConversationId,
            Code: cachedConversationCode,
            Name: cachedConversationName,
            Order: 0,
            Actions: cachedActions,
            Properties: {
                Views: viewCount,
                FreeViewsLeft: View.isFreeArticleAvailable() || 0,
                ArticleLeft: View.isFreeArticleAvailable() || 0,
                ViewType: null,
                Date: {
                    Started: ((_a = View.getConversationStartDate()) === null || _a === void 0 ? void 0 : _a.toISOString()) || null,
                    Expiration: null
                }
            }
        };
    }
    GetCurrentConversations() {
        return localStorageService.get(StorageKeys.Conversations.Current, { expandKey: false }) || [];
    }
    GetCurrentConversationViewCount() {
        return View.getCurrentConversationViewCount() || 0;
    }
    GetCurrentDynamicMeterViewCount() {
        return View.getCurrentDynamicMeterViewCount() || 0;
    }
    GetCurrentMeterLevel() {
        var _a;
        return ((_a = View.activeMeterView) === null || _a === void 0 ? void 0 : _a.meterLevel) || null;
    }
    GetSiteCode() {
        return AppOptions.getSiteCode() || '';
    }
    GetConfigCode() {
        return AppOptions.getConfigCode() || '';
    }
    GetLastPublishDate() {
        return localStorageService.get(StorageKeys.LastPublishDate, { expandKey: false }) || '';
    }
    GetRegistrationType() {
        return '';
    }
    GetViewedArticles() {
        const code = View.getActiveConversationCode();
        return code ? View.getViewedArticles(code) || [] : [];
    }
    GetArticlesLeft() {
        return View.isFreeArticleAvailable() || 0;
    }
    GetUserState() {
        var _a;
        return ((_a = UserStore.getUser()) === null || _a === void 0 ? void 0 : _a.UserState) || 'LoggedOut';
    }
    GetUserData() {
        return UserStore.getUser() || null;
    }
    GetUserProfile() {
        return UserStore.getUser() || null;
    }
    GetActualZipCodes() {
        const user = UserStore.getUser();
        return (user === null || user === void 0 ? void 0 : user.ZipCodes) || [];
    }
    GetUserZipCodes() {
        const user = UserStore.getUser();
        return (user === null || user === void 0 ? void 0 : user.ZipCodes) || [];
    }
    GetConnextPaywallCookie() {
        return null;
    }
    ClearUser() {
        UserStore.clearUser();
    }
}
